export class RtEdiTransType {
    constructor(public id: string, public name: string) {}
}
